import { Assets, detectCompressedTextures, extensions, utils } from 'pixi.js';

/** Register the Canvas backend before YAGE creates its shared Pixi application. */
export async function prepareAirportGraphics(): Promise<void> {
    if (!utils.isWebGLSupported()) await import('pixi.js-legacy');
    // All airport textures are PNGs. Pixi 7's compressed-format detector dereferences
    // an unset context after a failed WebGL probe, including on the Canvas path.
    extensions.remove(detectCompressedTextures);
    await Assets.init({ texturePreference: { format: ['png'] } });
}
